module.exports = __webpack_public_path__ + "img/mestre_simposios_badge.b269240d.png";